module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"listIsEmpty":"List is empty.","noDataToShow":"No data to show.","clear":"clear","addMore":"Add more...","add":"Add"},"ru":{"listIsEmpty":"Список пуст.","noDataToShow":"Нет данных.","clear":"очистить","addMore":"Добавить ещё...","add":"Добавить"},"ua":{"listIsEmpty":"Список порожній.","noDataToShow":"Дані відсутні.","clear":"очистити","addMore":"Додати ще...","add":"Додати"}}')
  delete Component.options._Ctor
}
